









import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/AdminProfile.css';

const AdminProfile = () => {
  const navigate = useNavigate();
  const [profileData, setProfileData] = useState({
    username: 'admin',
    email: 'admin@eclpuyvast.com',
    role: 'Administrator'
  });
  
  const [passwordData, setPasswordData] = useState({
    currentPassword: '',
    newPassword: '',
    confirmPassword: ''
  });
  
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  
  useEffect(() => {
    // Check if user is logged in
    const isAdmin = sessionStorage.getItem('isAdmin');
    if (isAdmin !== 'true') {
      navigate('/login');
    }
  }, [navigate]);
  
  const handlePasswordChange = (e) => {
    setPasswordData({
      ...passwordData,
      [e.target.name]: e.target.value
    });
  };
  
  const handlePasswordSubmit = (e) => {
    e.preventDefault();
    
    // Clear previous messages
    setError('');
    setSuccess('');
    
    // Simple validation
    if (passwordData.newPassword !== passwordData.confirmPassword) {
      setError("New passwords don't match");
      return;
    }
    
    if (passwordData.newPassword.length < 6) {
      setError("New password must be at least 6 characters");
      return;
    }
    
    // Here you would normally send a request to your backend to change the password
    // For this demo, we'll just show a success message
    
    setSuccess("Password updated successfully");
    setPasswordData({
      currentPassword: '',
      newPassword: '',
      confirmPassword: ''
    });
  };
  
  const handleBack = () => {
    navigate('/inland-logistics');
  };
  
  return (
    <div className="admin-profile">
      <div className="admin-header">
        <h1>Admin Profile</h1>
        <button onClick={handleBack} className="back-button">
          Back to Inland Logistics
        </button>
      </div>
      
      {error && <div className="admin-error">{error}</div>}
      {success && <div className="admin-success">{success}</div>}
      
      <div className="profile-container">
        <div className="profile-section">
          <h2>Profile Information</h2>
          <div className="profile-details">
            <div className="profile-item">
              <span className="profile-label">Username:</span>
              <span className="profile-value">{profileData.username}</span>
            </div>
            <div className="profile-item">
              <span className="profile-label">Email:</span>
              <span className="profile-value">{profileData.email}</span>
            </div>
            <div className="profile-item">
              <span className="profile-label">Role:</span>
              <span className="profile-value">{profileData.role}</span>
            </div>
          </div>
        </div>
        
        <div className="profile-section">
          <h2>Change Password</h2>
          <form onSubmit={handlePasswordSubmit} className="profile-form">
            <div className="form-group">
              <label>Current Password</label>
              <input
                type="password"
                name="currentPassword"
                value={passwordData.currentPassword}
                onChange={handlePasswordChange}
                required
              />
            </div>
            <div className="form-group">
              <label>New Password</label>
              <input
                type="password"
                name="newPassword"
                value={passwordData.newPassword}
                onChange={handlePasswordChange}
                required
              />
            </div>
            <div className="form-group">
              <label>Confirm New Password</label>
              <input
                type="password"
                name="confirmPassword"
                value={passwordData.confirmPassword}
                onChange={handlePasswordChange}
                required
              />
            </div>
            <button type="submit" className="profile-button">
              Update Password
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AdminProfile;